import {Injectable} from '@angular/core';
import {ScgHttpWrapper} from '@app/core/injectables/scg-http-wrapper';
import {NGXLogger} from 'ngx-logger';
import {environment} from '../../../environments/environment';
import {DeviceService} from '@app/core/services/device.service';
import {DeviceType} from '@app/core/models/device';

@Injectable({
  providedIn: 'root'
})
export class ProfilesService {

  constructor(private scgHttp: ScgHttpWrapper,
              private device: DeviceService,
              private log: NGXLogger) {
  }


  public getProfileList() {
    return this.scgHttp.get<{ any }>(environment.apiUrl + 'profiles/list');
  }


  public deleteProfile(postdata: any) {
      return this.scgHttp.post<any>(environment.apiUrl + '/profiles/delete', postdata);
  }


  public profileExists(filename: string) {
    const postData = {fileName: filename};
    return this.scgHttp.post<any>(environment.apiUrl + '/profiles/exists', postData);
  }


  public profileLoad(filename: string) {
    const postData = {fileName: filename};
    if (this.isCBDevice()) {
      return this.scgHttp.post<any>(environment.apiUrl + '/profiles/load', postData);
    } else {
      const username = this.device.activeDevice.username;
      return this.scgHttp.post<any>(environment.apiUrl + '/profiles/' + username + '/load', postData);
    }
  }


  public profileSave(filename: string) {
    const postData = {fileName: filename};
    if (this.isCBDevice()) {
      return this.scgHttp.post<any>(environment.apiUrl + '/profiles/save', postData);
    } else {
      const username = this.device.activeDevice.username;
      return this.scgHttp.post<any>(environment.apiUrl + '/profiles/' + username + '/save', postData);
    }
  }


  private isCBDevice(): boolean {
    if (this.device.activeDevice.device.type === DeviceType.CC) return false;
    return true;
  }

















}
